import { Staff } from '@/@types/staff';
import { Modal } from '@/components/common';
import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton, LinearProgress } from '@mui/material';
import { StaffForm, StaffFormData } from '../StaffForm';
import { StaffFormPlaceholder } from '../StaffForm/StaffFormPlaceholder';

interface IStaffModalProps {
  staff?: Staff;
  initialValues?: Partial<StaffFormData>;
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: StaffFormData) => void;
}

export function StaffModal({
  staff,
  initialValues,
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  isSubmitting,
}: IStaffModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle id="scroll-dialog-title" sx={{ p: 2 }}>
        {staff ? 'Alterar Colaborador' : 'Novo Colaborador'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {isSubmitting ? <LinearProgress /> : null}
      {isLoading ? (
        <StaffFormPlaceholder />
      ) : (
        <StaffForm
          staff={staff}
          initialValues={initialValues}
          isLoading={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
}
